export default __webpack_public_path__ + "static/media/61fac05b128899141cd776a133b00e171575987067398.2ce2437f.webp";